/** Asphalt */
export const alternateGray = '#5C6779'
/** Indigo 500 */
export const baseColor = '#3F51B5'
export const blueTextColor = '#254796'
/** Ash */
export const borderColor = '#D4DAE3'
/** White */
export const darkBackgroundIconColor = '#FFFFFF'
/** Lightblue */
export const darkBackgroundLinkColor = '#ADD8E6'
/** Coin */
// Don't use this for text, insufficient contrast
export const disabledIconColor = '#8B95A6'
/** light grey */
export const csvReaderBackground = '#f4f4f4'
/** light pink */
export const errorBackgroundColor = '#FBEAF1CC'
/** Pink 500 */
export const errorIconColor = '#E91E63'
/** Red */
export const errorTextColor = '#D32F2F'
/** Gray */
export const gray = '#b8bfcb'
export const greenTextColor = '#065A09'
/** Indigo 50 */
export const hoverColor = '#E8EAF6'
export const lightBlueBackground = '#E9F0FD'
export const lightGreenBackground = '#E8F5E9'
export const lighterBlueBackground = '#E9F9FF'
export const linkColor = '#3672E0'
export const linkHoverColor = '#1C50B0'
/** Gray 1 */
export const linkTextColor = '#333333'
/** Pink */
export const notifColor = '#E91E63'
/** Powder */
export const offsetGray = '#EFF1F3'
/** Term Container Gray */
export const offsetGray2 = '#F9FAFE'
/** Indigo 700 */
export const primaryDarkColor = '#303F9F'
export const primaryGreen = '#61E8AB'
/** Charcoal */
export const primaryTextColor = '#222C3D'
/** Yellow 600 */
export const primaryYellow = '#FDD835'
/** Cloud */
export const secondaryGrayColor = '#E1E6EF'
/** Gray 2 */
export const secondaryTextColor = '#5C6879'
export const snackbarErrorColor = '#EB548E'
export const snackbarInfoColor = '#98C6FF'
export const snackbarSuccessColor = '#03DAC6'
export const successTextColor = '#6BC96B'

/** Graphing Colors */
export const indigo500 = '#3F51B5'
export const lightBlue = '#1CAADE'
export const orange = '#EE9C3A'
export const pink = '#EB548E'
export const purple = '#AF4BD0'
export const red = '#DE542D'
export const teal = '#23D4D4'
export const yellow = '#E7E54E'

/** Specifies the color buckets for the charting libraries to use.
 *  Mapped graphColors to the "colors" setting for highcharts
 *  See PieCharts.tsx for an example
 */
export const graphColors = [
  [indigo500],
  [indigo500, pink],
  [indigo500, teal, pink],
  [indigo500, teal, purple, pink],
  [indigo500, teal, purple, pink, yellow],
  [indigo500, teal, purple, pink, orange, yellow],
  [indigo500, lightBlue, teal, purple, pink, orange, yellow],
  [indigo500, lightBlue, teal, purple, pink, red, orange, yellow]
]
